/**
 * Returns the value of a deeply nested key within an object, or undefined if the path to the key does not exist.
 * @param {Object} obj The object
 * @param  {...string} keys The path to the key
 * @returns {any} The value of the last key, or undefined if not found
 * @example
 * // returns 'cat'
 * getNestedValue({ foo: { bar: { baz: cat }}}, 'foo', 'bar', 'baz');
 * @example
 * // returns undefined
 * getNestedValue({ foo: { bar: { baz: cat }}}, 'foo', 'wrong_key', 'baz');
 */
const getNestedValue = (obj, ...keys) => {
  return keys.reduce((agg, level) => agg && agg[level], obj);
};

/**
 * Check is the provided value is a non-empty array.
 * @param {any} value Value to check
 * @returns {bool}
 */
const isNotEmptyArray = value => Array.isArray(value) && !!value.length;

export { getNestedValue, isNotEmptyArray };
